module.exports = __webpack_public_path__ + "img/168.90d44bf4.jpg";